import React, { useState, useRef, useEffect } from "react";
import { useHistory } from "react-router-dom";
import mixpanel from "mixpanel-browser";
import { mixPanelToken, isStage } from "../../config";

const options = [
  { value: "BUSOWNER", label: "MG" },
  { value: "ELECTRIC", label: "ELECTRIC" },
  { value: "OPERATOR", label: "GDS" },
];

const BusinessModelDropdown = (props) => {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(props.userType);
  const ref = useRef();

  const handleSelect = (value) => {
    mixpanel.init(mixPanelToken, { debug: isStage });
    mixpanel.track("Business Model Selected", {
      view_from: "login page",
      mobile_number: props.mobileNo,
      business_model_type: value,
      // type: props.userType,
    });

    setSelected(value);
    setOpen(false);
    sessionStorage.setItem("userType", value);
    if (window.location.pathname === "/") {
      window.location.reload();
    } else {
      window.location.href = "/";
    }
  };

  const display = options.find((opt) => opt.value === selected)?.label;

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div
      ref={ref}
      style={{
        width: "fit-content",
        position: "relative",
        fontFamily: "sans-serif",
      }}
    >
      <div
        onClick={() => setOpen(!open)}
        style={{
          backgroundColor: "#f5f5f5",
          borderRadius: "12px",
          padding: "12px 16px",
          fontSize: "16px",
          fontWeight: 500,
          color: "#1a1a1a",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          cursor: "pointer",
          minWidth: "260px",
        }}
      >
        <span>
          Business Model: <b>{display}</b>
        </span>
        <span
          style={{ marginLeft: "12px", color: "#7c3aed", fontSize: "12px" }}
        >
          ▼
        </span>
      </div>

      {open && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            marginTop: "4px",
            backgroundColor: "#fff",
            borderRadius: "8px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            zIndex: 100,
            minWidth: "100%",
          }}
        >
          {options.map((opt) => (
            <div
              key={opt.value}
              onClick={() => handleSelect(opt.value)}
              style={{
                padding: "10px 16px",
                cursor: "pointer",
                backgroundColor: selected === opt.value ? "#f0f0f0" : "#fff",
                fontWeight: selected === opt.value ? "bold" : "normal",
              }}
            >
              {opt.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default BusinessModelDropdown;
